<div
  class="relative inline-flex min-w-0 max-w-full items-center gap-1.5 overflow-visible rounded-full bg-whitegrey py-1 pl-1 not-italic dark:bg-black"
  [ngClass]="[containerClasses, removable ? 'pr-5' : 'pr-2']"
>
  <app-user-avatar
    [name]="label"
    [picture]="picture"
    [size]="avatarSize"
  ></app-user-avatar>
  <span class="inline-flex min-w-0 items-baseline gap-1">
    <span class="min-w-0 truncate text-sm font-bold text-black dark:text-white">
      {{ label }}
    </span>
    @if (metaLabel) {
    <span class="shrink-0 text-sm italic text-grey dark:text-borders-dark">
      {{ metaLabel }}
    </span>
    }
  </span>
  @if (removable) {
  <button
    type="button"
    class="absolute right-1 top-1/2 flex h-3.5 w-3.5 -translate-y-1/2 items-center justify-center text-grey transition-colors hover:text-black disabled:cursor-default disabled:opacity-40 dark:text-lightGrey dark:hover:text-white"
    [attr.aria-label]="removeLabel"
    [disabled]="disabled"
    (click)="onRemove($event)"
  >
    <span
      class="block h-2 w-2 bg-current"
      style="
        mask: url(&quot;/assets/images/icons/close.svg&quot;) center / 8px 8px
          no-repeat;
        -webkit-mask: url(&quot;/assets/images/icons/close.svg&quot;) center /
          8px 8px no-repeat;
      "
    ></span>
  </button>
  }
</div>
